(() => {
  angular.module("akitabox.ui.dialogs.asset.costAdjustment", [
    "ngMaterial",
    "akitabox.core.toast",
    "akitabox.core.services.costAdjustment",
    "akitabox.core.services.costAdjustmentRule",
    "akitabox.core.services.flag",
    "akitabox.core.services.organization",
    "akitabox.ui.dialogs",
  ]);
})();
